module.exports = __webpack_public_path__ + "static/img/eye.70635fe4.svg";